'use strict';/* global define */define('modules/ui/services/tree-utils/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["_"];
function factory(_){// jshint validthis:true
// jshint latedef:false
return{getFlattenedTreeOfNode:getFlattenedTreeOfNode,getReversedTree:getReversedTree,forEachChildNode:forEachChildNode};// ---
/**
     * Retrieve a flattened tree representation of a node and
     * of it's children and their children, and so on...
     *
     * @param  {Object}           node  node
     * @param  {Attay|undefined}  tree  tree ( ONLY for RECURSIVE USAGE INTERNALLY )
     * @param  {Number|undefined} level level ( ONLY for RECURSIVE USAGE INTERNALLY )
     *
     * @return {Array}            flattened Tree
     *
     * @tested
     */function getFlattenedTreeOfNode(node,tree,level){tree=tree||[];level=level||0;node.level=level;tree.push(_.pick(node,['name','description','loading','id','parentId','isActive','level']));if(node.children&&node.children.length){level++;node.children.forEach(function(kid){kid.parentId=node.id;getFlattenedTreeOfNode(kid,tree,level);});}return tree;}/**
     * Get a completely recursive reversed tree of the handed in one
     *
     * @param  {Array} tree tree
     * @return {Array}      reversed tree
     *
     * @tested
     */function getReversedTree(tree){tree=_(tree).reverse().value();tree.forEach(function(node){if(node.children){node.children=getReversedTree(node.children);}});return tree;}/**
     * Iterate over each of the children nodes of a tree structures
     * and execute a provided callback function for every one of them
     *
     * @param  {Array}    collection - List of items
     * @param  {Object}   node       - Single node object
     * @param  {Function} callback   - Callback function
     *
     * @tested
     */function forEachChildNode(collection,node,callback){_.forEach(collection,function(item){if(item.parentId===node.id){forEachChildNode(collection,item,callback);callback(item);}});}}module.exports=factory;});
